// dev server base url
export const BASE_URL = process.env.VUE_APP_BASE_API_URL || "https://dev.api.tech-square.co.kr/";
// concat the api base url
export const API_BASE_URL = `${BASE_URL}api/v1/`;